import React, { useCallback, useMemo } from 'react'
import { Box, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { ManWithError } from '~/assets/illustrations'
import { FallbackPageContent } from '~/components'
import { mutualTheme } from '~/utils/theme'
import * as icons from '~/assets/icons'
import { useHistory } from 'react-router-dom'
import { useIsSmallScreen } from '~/hooks'

export type PageNotFoundProps = {
  returnPath?: string,
  description?: string,
  buttonProps?: {
    icon: keyof typeof icons,
    text: string
  },
  fullscreen?: boolean
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    flexDirection: 'column',
    margin: '0 auto',
    [mutualTheme.breakpoints.up('sm')]: {
      maxWidth: 580
    }
  },
  button: {
    height: 50
  }
})

export const PageNotFound: React.FC<PageNotFoundProps> = (props) => {
  const { returnPath, buttonProps, description, fullscreen } = props
  const history = useHistory()
  const classes = useStyles()

  const onNavigate = useCallback(() => {
    history.push(returnPath || '/')
  }, [history, returnPath])

  const IconComponent = useMemo(() => {
    if (buttonProps) {
      return icons[buttonProps.icon]
    }
    return icons.ClockIcon
  }, [buttonProps])

  const isSmallScreen = useIsSmallScreen()

  return (
    <Box className={classes.container} sx={{
      height: fullscreen ? '100vh' : '100%'
    }}>
      <ManWithError height={isSmallScreen ? 115 : undefined} />

      <FallbackPageContent
        title='Ops, página não encontrada'
        description={description || 'A página que você está procurando não existe. Por favor verifique a sua URL ou se você continuar tendo problemas, volte para a seção de visão geral:'}
      />

      <Button
        className={classes.button}
        variant='contained'
        color='primary'
        startIcon={IconComponent && !isSmallScreen && <IconComponent />}
        onClick={onNavigate}
        size='large'
      >
        {(buttonProps && buttonProps.text) ? buttonProps.text : 'Ir para a visão geral'}
      </Button>
    </Box>
  )
}
